if (!customElements.get("velvet-review-slider")) {
  class VelvetReviewSlider extends HTMLElement {
    connectedCallback() {
      this.initializationFrame = null;
      this.initializationAttempts = 0;
      this.slider = null;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.initializeWhenReady();
    }

    disconnectedCallback() {
      if (this.initializationFrame) {
        window.cancelAnimationFrame(this.initializationFrame);
      }

      document.removeEventListener(
        "shopify:block:select",
        this.handleBlockSelect,
      );

      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
      }
    }

    initializeWhenReady() {
      if (
        window.MinimogLibs &&
        typeof window.MinimogLibs.Swiper === "function"
      ) {
        this.initializeSlider();
        return;
      }

      this.initializationAttempts += 1;
      if (this.initializationAttempts > 180) return;

      this.initializationFrame = window.requestAnimationFrame(() => {
        this.initializeWhenReady();
      });
    }

    initializeSlider() {
      const viewport = this.querySelector(".swiper-container");
      const slides = this.querySelectorAll("[data-velvet-review-slide]");

      if (!viewport || slides.length === 0 || this.slider) return;

      const previousButton = this.querySelector(
        "[data-velvet-reviews-previous]",
      );
      const nextButton = this.querySelector("[data-velvet-reviews-next]");
      const pagination = this.querySelector(
        "[data-velvet-reviews-pagination]",
      );
      const autoplay = this.dataset.autoplay === "true";
      const autoplaySpeed =
        Math.max(3, Number.parseInt(this.dataset.autoplaySpeed, 10) || 6) *
        1000;
      const desktopSlides = Math.max(
        2,
        Number.parseInt(this.dataset.desktopSlides, 10) || 3,
      );
      const tabletSlides = Math.max(
        1,
        Number.parseInt(this.dataset.tabletSlides, 10) || 2,
      );

      this.slider = new window.MinimogLibs.Swiper(viewport, {
        slidesPerView: 1.08,
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 600,
        grabCursor: true,
        watchOverflow: true,
        autoHeight: false,
        loop: this.dataset.loop === "true",
        autoplay: autoplay
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: tabletSlides,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: Math.min(3, desktopSlides),
            spaceBetween: 28,
          },
          1280: {
            slidesPerView: desktopSlides,
            spaceBetween: 30,
          },
        },
      });

      document.addEventListener(
        "shopify:block:select",
        this.handleBlockSelect,
      );
    }

    handleBlockSelect(event) {
      if (!this.slider || !this.contains(event.target)) return;

      const selectedSlide = event.target.closest(
        "[data-velvet-review-slide]",
      );
      if (!selectedSlide) return;

      const slideIndex = Number.parseInt(selectedSlide.dataset.slideIndex, 10);
      if (Number.isNaN(slideIndex)) return;

      if (this.dataset.loop === "true" && this.slider.slideToLoop) {
        this.slider.slideToLoop(slideIndex);
      } else {
        this.slider.slideTo(slideIndex);
      }

      if (this.slider.autoplay) {
        this.slider.autoplay.stop();
      }
    }
  }

  customElements.define("velvet-review-slider", VelvetReviewSlider);
}
